import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { showTabbar: true } // 首页显示Tabbar
  },
  {
    path: '/courses',
    name: 'courses',
    component: () => import('../views/CoursesView.vue'),
    meta: { showTabbar: true } // 课程列表显示Tabbar
  },
  {
    path: '/course/:id',
    name: 'course-detail',
    component: () => import('../views/CourseDetailView.vue'),
    meta: { showTabbar: false } // 课程详情不显示Tabbar
  },
  {
    path: '/video/:courseId/:lessonId?',
    name: 'video-learning',
    component: () => import('../views/VideoLearningView.vue'),
    meta: { showTabbar: false } // 视频学习不显示Tabbar
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import('../views/JobsView.vue'),
    meta: { showTabbar: true } // 就业页显示Tabbar
  },
  {
    path: '/job/:id',
    name: 'job-detail',
    component: () => import('../views/JobDetailView.vue'),
    meta: { showTabbar: false } // 职位详情不显示Tabbar
  },
  {
    path: '/product/:id',
    name: 'product-detail',
    component: () => import('../views/ProductDetailView.vue'),
    meta: { showTabbar: false } // 产品详情不显示Tabbar
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/CertificateView.vue'),
    meta: { 
      showTabbar: true // 证书鉴别页显示Tabbar
    }
  },
  {
    path: '/talent',
    name: 'talent',
    component: () => import('../views/TalentView.vue'),
    meta: { showTabbar: true } // 人才页显示Tabbar
  },
  {
    path: '/talent/:id',
    name: 'talent-detail',
    component: () => import('../views/TalentDetailView.vue'),
    meta: { showTabbar: false } // 人才详情不显示Tabbar
  },
  {
    path: '/exams',
    name: 'exams',
    component: () => import('../views/ExamsView.vue'),
    meta: { showTabbar: true } // 考证页显示Tabbar
  },
  {
    path: '/exam/:id',
    name: 'exam-detail',
    component: () => import('../views/ExamDetailView.vue'),
    meta: { showTabbar: false } // 考试详情不显示Tabbar
  },
  {
    path: '/quizzes',
    name: 'quizzes',
    component: () => import('../views/QuizView.vue'),
    meta: { showTabbar: true } // 题库页显示Tabbar
  },
  {
    path: '/quiz/:id',
    name: 'quiz-detail',
    component: () => import('../views/QuizDetailView.vue'),
    meta: { showTabbar: false } // 题库详情不显示Tabbar
  },
  {
    path: '/quiz-practice/:id',
    name: 'quiz-practice',
    component: () => import('../views/QuizPracticeView.vue'),
    meta: { showTabbar: false } // 题库练习不显示Tabbar
  },
  {
    path: '/payment/:id?',
    name: 'payment',
    component: () => import('../views/PaymentView.vue'),
    meta: { showTabbar: false } // 支付页不显示Tabbar
  },
  {
    path: '/payment-success',
    name: 'payment-success',
    component: () => import('../views/PaymentSuccessView.vue'),
    meta: { showTabbar: false } // 支付成功页不显示Tabbar
  },
  {
    path: '/tcm-registration',
    name: 'tcm-registration',
    component: () => import('../views/TcmRegistrationView.vue'),
    meta: { showTabbar: false } // 中医报名页不显示Tabbar
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { showTabbar: true } // 个人中心显示Tabbar
  },
  {
    path: '/help',
    name: 'help-center',
    component: () => import('../views/HelpCenterView.vue'),
    meta: { showTabbar: false } // 帮助中心不显示Tabbar
  },
  {
    path: '/notices',
    name: 'notices',
    component: () => import('../views/NoticesView.vue'),
    meta: { showTabbar: false } // 通知列表不显示Tabbar
  },
  {
    path: '/notice/:id',
    name: 'notice-detail',
    component: () => import('../views/NoticeDetailView.vue'),
    meta: { showTabbar: false } // 通知详情不显示Tabbar
  },
  {
    path: '/exam-ticket',
    name: 'exam-ticket',
    component: () => import('../views/ExamTicketView.vue'),
    meta: { showTabbar: false }
  },
  {
    path: '/certificate-mailing',
    name: 'certificate-mailing',
    component: () => import('../views/CertificateMailingView.vue'),
    meta: { showTabbar: false } // 证书邮寄不显示Tabbar
  }
]

const router = new VueRouter({
  routes,
  // 配置滚动行为，确保每次路由切换时都滚动到页面顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（例如浏览器前进/后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到页面顶部
    return { x: 0, y: 0 }
  }
})

// 路由守卫：未登录用户无法访问需要认证的页面
router.beforeEach((to, from, next) => {
  // 检查是否是非桌面端（屏幕宽度小于 1024px）
  const isMobile = window.innerWidth < 1024
  
  // 通过 Vuex store 判断登录状态
  const isLoggedIn = store.getters.isLoggedIn
  
  // 如果是访问个人中心页面
  if (to.path === '/profile') {
    // 在非桌面端需要检查登录状态
    if (isMobile && !isLoggedIn) {
      // 未登录，重定向到首页
      next('/')
      return
    }
  }
  
  // 检查路由是否需要登录
  if (to.meta.requiresAuth && !isLoggedIn) {
    // 未登录，显示登录弹框并停留在当前页面
    store.commit('SHOW_LOGIN_MODAL')
    // 重定向到首页
    next('/')
    return
  }
  
  next()
})

// 在Vue实例上添加全局401处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error('全局错误处理:', err, info)
}

// 设置axios响应拦截器的401处理
const setupGlobalErrorHandling = () => {
  // 这个函数会在main.js中被调用，用于设置全局错误处理
  window.addEventListener('unhandledrejection', event => {
    const error = event.reason
    
    // 检查是否是401错误
    if (error && error.status === 401) {
      // 获取当前路由路径
      const currentPath = router.currentRoute.path
      
      // 支付相关页面不自动logout（让页面自己处理）
      const paymentRelatedPages = ['/payment', '/payment-success']
      const isPaymentPage = paymentRelatedPages.some(page => currentPath.startsWith(page))
      
      if (!isPaymentPage && !error.needAuth) {
        // 非支付页面的401错误，执行logout
        store.dispatch('logout')
        
        // 如果当前在需要登录的页面，跳转到首页
        if (currentPath === '/profile') {
          router.push('/')
        }
      }
    }
  })
}

// 导出设置函数
export { setupGlobalErrorHandling }
export default router
